import { BasePageTrackingService } from '../BasePageTrackingService';

export class VisibilityTrackingService extends BasePageTrackingService {}
